module.exports = __webpack_public_path__ + "img/Logo_SOC_LAF.6663ee77.svg";